import { Component, Input, OnInit } from '@angular/core';
import { EstimacionParadaModel } from 'src/app/shared/models/regulares/estimacionParada.model';
import { LineaModel } from 'src/app/shared/models/regulares/linea.model';

@Component({
  selector: 'app-timeline-paradas',
  templateUrl: './timeline-paradas.component.html',
  styleUrls: ['./timeline-paradas.component.css']
})
export class TimelineParadasComponent implements OnInit {
  @Input()
  estimaciones: EstimacionParadaModel[];
  @Input()
  estimacionesMostradas: EstimacionParadaModel[] = [];
  @Input()
  linea: LineaModel;
  @Input()
  layout : string = "vertical";
  colorNextSteps: string = "#4caf50";
  colorCurrenttStop: string = '#ff4032';
  colorPreviousStops: string = '#757575';
  iconBus: string = 'fa-solid fa-bus-simple'
  iconLlegaParada: string = 'fa-bounce';
  @Input()
  rangeParadasShow: number;

  constructor() { }

  ngOnInit(): void {
    this.buildEstimacionesToShow();
  }

  //#region builds

  buildEstimacionesToShow(){
    if(this.rangeParadasShow){
      var indexActiva = this.getParadaActiva();
      if(indexActiva !== -1){
        const start = Math.max(0, indexActiva - 3);
        const end = Math.min(this.estimaciones.length, indexActiva + 4);
        this.estimacionesMostradas = this.estimaciones.slice(start, end);
        return;
      }
     
    }
    this.estimacionesMostradas = this.estimaciones;
    
  }

  buildTextParada(index: number,item: EstimacionParadaModel){
    return `[${index}] ${item.hora_paso} ${item.nomparada}`;
  }

  get buildIconBus() : string{
    return this.iconBus;
  }

  get buildIconBusStop() : string{
    return `${this.iconBus} ${this.iconLlegaParada}`;
  }

  //#endregion

  getParadaActiva(){
    return this.estimaciones.findIndex(x => x.siguienteParada)
  }

  getDesfaseColor(desfase: number) {
    if(this.linea && desfase){
      let color: string;
      var linea = this.linea;
      if (desfase < linea.mbMAdelantado) {
        color = linea.cbMAdelantado;
      } else if (desfase > linea.mbMAdelantado && desfase <= linea.mbAdelantado) {
        color = linea.cbAdelantado;
      } else if (desfase > linea.mbMAdelantado && desfase < linea.mbRetrasado) {
        color = linea.cbHora;
      } else if (desfase >= linea.mbRetrasado && desfase < linea.mbMRetrasado) {
        color = linea.cbRetrasado;
      } else {
        color = linea.cbMRetrasado;
      }
    
      return color;
    }
    
  }
  
  getColorStep(estimacion: EstimacionParadaModel){
    if(estimacion.siguienteParada){
      return this.colorCurrenttStop;
    }
    var currentStep = this.estimaciones.find(x => x.siguienteParada);
    if(currentStep){
      if(currentStep.numorden > estimacion.numorden){
        return this.colorNextSteps;
      }else{
        return this.colorPreviousStops;
      }

    } 


    return;
  }
  
}
